import { useQuery } from '@tanstack/react-query';

import { Interval } from '@/app/shared/constants/interval';
import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { formatVaultTvl } from '@/app/shared/lib/vaultFormatters';
import { getVaults } from '@/app/shared/services/api';

export const useHeaderTvl = () => {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKeys.VAULTS, 'current'],
    queryFn: () => getVaults('current'),
    staleTime: Interval.ONE_MIN,
    refetchInterval: Interval.ONE_MIN,
  });

  const totalTvlUsd = (data ?? []).reduce((sum, vault) => {
    const value = Number(vault.tvlBaseUsd ?? vault.tvlBase ?? 0);
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);

  return {
    tvl: formatVaultTvl(String(totalTvlUsd)),
    isLoading,
  };
};
